import Splide from "@splidejs/splide";

document.addEventListener("DOMContentLoaded", function () {
	function initializeSimpleSlider(selector) {
		const sliderElements = document.querySelectorAll(selector);
		// If Sliderelemnt can not be find, exit the function
		if (!sliderElements) return;

		if (sliderElements.length > 0) {
			sliderElements.forEach(function (sliderElement) {
				let splideInstance; // Declare splideInstance here, in the forEach loop's scope

				if (sliderElement.splide) {
					// Check if a Splide instance already exists on sliderElement and destroys it before initializing a new one.
					sliderElement.splide.destroy();
				}

				// Prevent duplicate initialization
				if (sliderElement.classList.contains("is-initialized")) return;
				sliderElement.classList.add("is-initialized");

				//
				// Initialize Splide slider and store the instance
				//
				splideInstance = new Splide(sliderElement, {
					type: "loop",
					perPage: 1,
					perMove: 1,
					rewind: true,
					arrows: false,
					gap: "2rem",
					pagination: false,
					mediaQuery: "min",
					autoplay: true,
					breakpoints: {
						768: {
							perPage: 2,
							gap: "2.4rem",
						},
						1200: {
							perPage: 3,
						},
						1500: {
							perPage: 4,
							drag: false,
						},
					},
				}).mount();

				//
				// If custom arrows need to be added
				//
				if (sliderElement.querySelector(".custom-arrows")) {
					// Create custom arrow elements if they don't exist
					if (!sliderElement.querySelector(".custom-prev")) {
						const prevButton = document.createElement("button");
						prevButton.classList.add("custom-prev");
						prevButton.textContent = "Prev"; // Or use an icon
						sliderElement.appendChild(prevButton);
					}
					if (!sliderElement.querySelector(".custom-next")) {
						const nextButton = document.createElement("button");
						nextButton.classList.add("custom-next");
						nextButton.textContent = "Next"; // Or use an icon
						sliderElement.appendChild(nextButton);
					}

					const prevButton =
						sliderElement.querySelector(".custom-prev");
					const nextButton =
						sliderElement.querySelector(".custom-next");

					// add event listener if buttons exists
					if (prevButton) {
						prevButton.addEventListener("click", () => {
							splideInstance.go("-1");
						});
					}
					if (nextButton) {
						nextButton.addEventListener("click", () => {
							splideInstance.go("+1");
						});
					}
				}
			});
		}
	}

	//Initialize slider for team which has an unique ID
	//Any other blocks which use similar style of slide can be initilzed from here
	initializeSimpleSlider("#team-slider");
});
